export default __webpack_public_path__ + "static/media/folder_move.cfe877ac.svg";